import {
    ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChildren, EventEmitter, Injectable, Input, Output,
    QueryList
} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
    selector: 'ng2-accordion',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="accordion">
            <div class="accordion__toggle" [class.opened]="isOpened" (click)="toggle()">
                <span>{{title}}</span>
                <a *ngIf="actionLink" href="javascript:;" (click)="onActionClick($event)">{{actionLink}}</a>
            </div>
            <div class="accordion__content" [class.hidden]="!isOpened">
                <ng-content></ng-content>
            </div>
        </div>
    `,
    styleUrls: ['./accordion.component.scss']
})

export class AccordionComponent {
    @Input() title = '';

    @Input() isOpened = false;

    @Input() actionLink = '';

    @Output() action = new EventEmitter();

    constructor(private cd: ChangeDetectorRef) {}

    toggle() {
        this.isOpened = !this.isOpened;
        this.cd.detectChanges();
    }

    onActionClick(event) {
        event.stopPropagation();
        this.action.emit();
    }
}

